// extracted by mini-css-extract-plugin
export default {"wrapper":"DataForm_wrapper__lw+MB","button":"DataForm_button__8LHIB"};